import React from 'react';
var useForceUpdate = function useForceUpdate() {
  var _React$useState = React.useState(0),
    setState = _React$useState[1];
  return React.useCallback(function () {
    return setState(function (state) {
      return state + 1;
    });
  }, [setState]);
};
export default useForceUpdate;